<div class="features-section">

  <div class="features-header">
    <p class="features-label">Why Sale Mobilizer</p>
    <h2>The POS system built for your success</h2>
    <p class="features-intro">Everything you need to run your store — fast billing, live inventory, and clear reports, all in one place.</p>
  </div>

  <div class="highlight-row">
    <div class="highlight-tile">
      <span class="highlight-icon">🗂️</span>
      <h3>Everything in One Place</h3>
      <p>Sales, inventory, customers, and reports in a single system.</p>
    </div>

    <div class="highlight-tile">
      <span class="highlight-icon">📊</span>
      <h3>Clear Reports</h3>
      <p>Track sales, profit, and stock instantly.</p>
    </div>

    <div class="highlight-tile">
      <span class="highlight-icon">📱</span>
      <h3>Mobile Access</h3>
      <p>Check and manage your business from your phone.</p>
    </div>

    <div class="highlight-tile">
      <span class="highlight-icon">🛡️</span>
      <h3>Reliable System</h3>
      <p>Works offline. Your data stays safe.</p>
    </div>
  </div>

  <div class="detail-list">
    <div class="detail-row">
      <span class="detail-icon">⚡</span>
      <span class="detail-title">Fast Billing &amp; Checkout</span>
      <span class="detail-desc">Barcode scanning, instant receipts, discounts, and auto tax.</span>
    </div>

    <div class="detail-row">
      <span class="detail-icon">📦</span>
      <span class="detail-title">Live Inventory Tracking</span>
      <span class="detail-desc">Product variants, SKU tracking, low stock alerts, purchase orders.</span>
    </div>

    <div class="detail-row">
      <span class="detail-icon">🔐</span>
      <span class="detail-title">Multi-User Access &amp; Roles</span>
      <span class="detail-desc">Secure logins with role-based permissions for your team.</span>
    </div>

    <div class="detail-row">
      <span class="detail-icon">📈</span>
      <span class="detail-title">Sales &amp; Inventory Reports</span>
      <span class="detail-desc">Exportable reports that show how your store is performing.</span>
    </div>
  </div>

</div>
